var auctionCountdown = '[data-bind=countdown]';
var millisecondsInASecond = 1000;
var secondsInAnHour = 3600;

function init() {
  if (lessThanAnHourLeft()) {
    bindCountdown();
  }
}

function bindCountdown() {
  $(auctionCountdown).countdown(endTime(), function (event) {
    $(this).html(event.strftime('%Mm %Ss'));
  });
}

function lessThanAnHourLeft() {
  var now = new Date();
  var millisecondsLeft = (endTime() - now);
  var secondsLeft = millisecondsToSecond(millisecondsLeft);
  return secondsLeft < secondsInAnHour;
}

function endTime() {
  var endTimeInSeconds = $(auctionCountdown).data('end_time');
  return new Date(secondsToMilliseconds(endTimeInSeconds));
}

function secondsToMilliseconds(seconds) {
  return seconds * millisecondsInASecond;
}

function millisecondsToSecond(milliseconds) {
  return milliseconds / millisecondsInASecond;
}

module.exports = {
  init,
  lessThanAnHourLeft,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/auctions/countdown.js